<template>
	<div class="vitae">
		<div class="group-content">
			<van-swipe-cell
				v-for="(item,ind) in vitaeList"
				:key="ind">

				<van-card
					:desc="item.remark||''"
					:style="'margin-bottom:10px;'"
				>
					<template #title>
						<span style="font-weight:bold;">{{item.content}}</span>
					</template>
					<template #num>
						<van-tag plain type="warning" v-if="item.in_clan">族谱展示</van-tag>
					</template>
					<template #price>
						{{item.date_vitae?item.date_vitae:(item.date_start+' 至 '+item.date_end)}}
					</template>
				</van-card>

				<template #right>
					<van-button square text="编辑" type="primary" @click="onEditVitae(item.id)" v-if="!readonly"/>
					<van-button square text="删除" type="danger" @click="onDelVitae(item.id)" v-if="!readonly"/>
				</template>

			</van-swipe-cell>

			<div class="empty" v-if="vitaeList.length==0">
				<span class="msg">没有相关信息！</span>
			</div>
		</div>

		<van-popup v-model="showEditVitae" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px' }">
			<van-cell-group > 
				<van-field
					v-model.trim="vitaeInfo.content"
					label="内容："
					required
					placeholder="请输入履历内容"
					clearable
				></van-field>
				<van-cell title="时间：" title-class="van-field__label">
					<template #default>{{vitaeInfo.date_vitae?vitaeInfo.date_vitae:(vitaeInfo.date_start||vitaeInfo.date_end?(vitaeInfo.date_start+' 至 '+vitaeInfo.date_end):'')}}</template>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="showPopup2VitaeTime" :style="{'margin-left':'5px'}">选 / 填</van-button></template>
				</van-cell>
				<van-field
				  v-model.trim="vitaeInfo.remark"
				  rows="3"
				  autosize
				  label="备注："
				  type="textarea"
				  maxlength="3000"
				  placeholder="请输入备注内容"
				  show-word-limit
				/>
				<van-cell
					:value="''"
					title-class="van-cell-title"
				>
					<template #title>
						<span class="custom-title">族谱展示：{{inclansChk?'是':'否'}}</span>
					</template>
					<template #right-icon>
						<van-switch v-model="inclansChk"  @input="onInclansChk"/>
					</template>
				</van-cell>

				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="9">
						<van-button type="default" block  @click="showEditVitae=false">取消</van-button>
					</van-col>
					<van-col span="1"></van-col>
					<van-col span="12">
						<van-button type="primary" block  @click="onSaveVitae">保存</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 

			</van-cell-group>
		</van-popup>

		<van-popup v-model="showVitaeTimePopup" position="bottom" :style="{'min-height':'200px', 'bottom':'50px'}">

				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="5">
						<van-sidebar v-model="sidebarActiveKey">
							<van-sidebar-item title="选择日期" />
							<van-sidebar-item title="手动输入" />
						</van-sidebar>
					</van-col>
					<van-col span="19">
						<van-cell-group > 
							<van-field
								v-model.trim="vitaeInfo.date_vitae"
								label=""
								placeholder="请输入履历时间"
								clearable
							v-if="sidebarActiveKey==1"
							></van-field>

							<van-cell
								title="起始日期："
								is-link
								:value="vitaeInfo.date_start"
								title-class="van-cell-title"
								v-if="sidebarActiveKey==0"
								@click="showVitaeTimePicker=1"
							>
								<template #right-icon>
									<van-icon name="arrow" class="van-cell__right-icon" />
									<van-button type="default" plain hairline size="mini" @click.stop="vitaeInfo.date_start=''" :style="{'margin-left':'5px'}">置空</van-button>
								</template>
							</van-cell>
							<van-cell
								title="结束日期："
								is-link
								:value="vitaeInfo.date_end"
								title-class="van-cell-title"
								v-if="sidebarActiveKey==0"
								@click="showVitaeTimePicker=2"
							>
								<template #right-icon>
									<van-icon name="arrow" class="van-cell__right-icon" />
									<van-button type="default" plain hairline size="mini" @click.stop="vitaeInfo.date_end=''" :style="{'margin-left':'5px'}">置空</van-button>
								</template>
							</van-cell> 
						</van-cell-group > 
					</van-col>
				</van-row> 
				<van-row  :style="{'margin-bottom':'10px'}" v-if="sidebarActiveKey==0&&showVitaeTimePicker>0">
					<van-col span="24">
						<van-cell-group>

							<van-datetime-picker
								type="date"
								:title="showVitaeTimePicker==1?'起始日期':'结束日期'"
								:min-date="new Date(1900, 0, 1)"
								:max-date="new Date()"
								
								@confirm="onConfirmVitaeTime"
								@cancel="showVitaeTimePicker=0"
							/>
						</van-cell-group > 
					</van-col>
				</van-row> 
				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="22">
						<van-button type="primary" block  @click="showVitaeTimePopup=false" :disabled="sidebarActiveKey==0&&showVitaeTimePicker>0">确定</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 
			
		</van-popup>

		<van-button square text="新增" type="default" class="btn_add" @click="onAddVitae" v-if="!readonly"/>

	</div>
</template>

<script>
import {Card, SwipeCell, Sidebar, SidebarItem, DatetimePicker } from "vant";

export default {
	name: "vitae",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell,
		"van-sidebar":Sidebar,
		"van-sidebar-item":SidebarItem,
		"van-datetime-picker":DatetimePicker
	},
	props:{
		p_id:Number,
		readonly:Boolean
	},
	data() {
		return {
			title: "履历信息管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),

			vitaeList:[],
			vitaeInfoObj:{},
			showEditVitae:false,
			vitaeInfo:{},
			showVitaeTimePopup:false,
			sidebarActiveKey:0,
			showVitaeTimePicker:0,
			inclansChk:false,
			saveFlag:false
		};
	},
	created() {
		this.getVitaeData();
	},
	computed: {
	},
	methods: {
		getVitaeData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.p_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalVitae" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.vitaeList = [];
				that.vitaeInfoObj = {};
				let edus = response.data.datas;
				if(edus && edus.length > 0){
					that.vitaeList = edus;
					for(var i=0,il=edus.length; i<il; i++){
						that.vitaeInfoObj[edus[i]['id']] = edus[i];
					};
				}
			})
			.catch(error => {});
		},
		showPopup2VitaeTime(){
			this.showVitaeTimePopup = true;
			this.sidebarActiveKey = this.vitaeInfo.date_vitae?1:0;
		},
		onAddVitae(){
			this.vitaeInfo = {p_id:this.p_id};
			this.showEditVitae = true;
		},
		onEditVitae(id){
			this.vitaeInfo = this.vitaeInfoObj[id];
			this.inclansChk = this.vitaeInfo.in_clan==1;
			this.showEditVitae = true;
		},
		onDelVitae(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/personalVitaeDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.getVitaeData();
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSaveVitae(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.vitaeInfo['content']){
				this.$toast.fail("请输入履历内容！");
				return false;
			}
			this.saveFlag = true;
			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.vitaeInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalVitaeSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.getVitaeData();
					that.showVitaeTimePopup = false;
					that.showEditVitae = false;
				}
			})
			.catch(error => {});
		},
		onConfirmVitaeTime(val){
			if(this.showVitaeTimePicker==1){
				this.vitaeInfo.date_start = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}else{
				this.vitaeInfo.date_end = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}
			this.showVitaeTimePicker=0;
			this.$forceUpdate();
		},
		onInclansChk(chk){
			this.vitaeInfo.in_clan = chk?1:0;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/Vitae.vue